import React from "react";
import { Link } from "react-router-dom";
import "./css/BannerStyle.css"; // You'll need to create this CSS file

const BannerFive = () => {
  return (
    <div className="ai-banner mt-4">
      <div className="container ">
        <div className="row align-items-center">
          <div className="col-lg-6">
            <div className="banner-content">
              <h1 className="banner-title ">
                Your Personal <span> Career Buddy </span> <br />
                Built With Innovation <br /> Guided By Mentors
              </h1>
              <p className="banner-description">
                Help students and working professionals reach their dream
                careers with curated learning path with industry experts and
                experienced mentors. Together, we create a journey of growth
                that’s tailored to individual's goals.
              </p>
              <div className="banner-buttons">
                <Link
                  to="/subscription"
                  className="btn btn-primary try-free-btn"
                >
                  Try for free{" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    viewBox="0 0 16 16"
                    className="ms-1"
                  >
                    <path
                      fillRule="evenodd"
                      d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                    />
                  </svg>
                </Link>
                <Link
                  to="/contact"
                  className="btn btn-outline-primary login-btn"
                >
                  Talk to an expert <i className="arrow-icon">→</i>
                </Link>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="dashboard-wrapper">
              <div className="dashboard-image">
                <img
                  src="/images/Front-img.jpg"
                  alt="AI Learning Platform Dashboard"
                  className="img-fluid"
                />
                {/* <div className="feature-badges">
                  <div className="feature-badge">
                    <span className="badge-icon">✓</span> Discover
                  </div>
                  <div className="feature-badge">
                    <span className="badge-icon">✓</span> Personalize
                  </div>
                  <div className="feature-badge">
                    <span className="badge-icon">✓</span> Connect
                  </div>
                  <div className="feature-badge">
                    <span className="badge-icon">✓</span> Engage
                  </div>
                  <div className="feature-badge">
                    <span className="badge-icon">✓</span> Track
                  </div>
                  <div className="feature-badge">
                    <span className="badge-icon">✓</span> Excel
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BannerFive;
